module.exports = __webpack_public_path__ + "img/icon_settings.cf0224c1.svg";